import { cn } from '@core/utils';
import type { CSSProperties } from 'react';

interface AdSlotFrameInput {
  unitIdM: string;
  unitIdP: string;
  mWidth: number;
  mHeight: number;
  pWidth: number;
  pHeight: number;
  showEmptyUnitPlaceholder: boolean;
}

//* frame의 브레이크포인트별 크기·노출은 JS 미디어쿼리가 아닌 CSS로만 결정한다.
//* useMediaQuery는 hydration 후에야 확정되므로 SSR 첫 페인트가 모바일 크기로 나간 뒤
//* 리사이즈·등장·사라짐 시프트가 생긴다. xl(1280px)은 BREAKPOINTS.DESKTOP과 동일 경계.
export const getAdSlotFrameProps = ({
  unitIdM,
  unitIdP,
  mWidth,
  mHeight,
  pWidth,
  pHeight,
  showEmptyUnitPlaceholder,
}: AdSlotFrameInput) => {
  const hasMobileSlot = Boolean(unitIdM) || showEmptyUnitPlaceholder;
  const hasDesktopSlot = Boolean(unitIdP) || showEmptyUnitPlaceholder;

  return {
    className: cn(
      'aspect-[var(--ad-frame-aspect-mobile)] w-[min(100%,var(--ad-frame-width-mobile))]',
      'xl:aspect-[var(--ad-frame-aspect-desktop)] xl:w-[min(100%,var(--ad-frame-width-desktop))]',
      !hasMobileSlot && 'hidden',
      hasDesktopSlot ? !hasMobileSlot && 'xl:block' : 'xl:hidden',
    ),
    style: {
      '--ad-frame-width-mobile': `${mWidth}px`,
      '--ad-frame-aspect-mobile': `${mWidth}/${mHeight}`,
      '--ad-frame-width-desktop': `${pWidth}px`,
      '--ad-frame-aspect-desktop': `${pWidth}/${pHeight}`,
    } as CSSProperties,
  };
};
